import {t} from '../common/getTranslations';
import {ErrorArea} from '../design-system/organisms/ErrorArea/ErrorArea';

export function UnknownError({
  isMobile,
  className,
  onClickRetry,
}: {
  isMobile: boolean;
  className?: string;
  onClickRetry?: () => void;
}) {
  return (
    <ErrorArea isMobile={isMobile} className={className}>
      <ErrorArea.Title>{t('error_api_title')}</ErrorArea.Title>
      <ErrorArea.MainText>{t('error_api_detail')}</ErrorArea.MainText>
      {onClickRetry && (
        <ErrorArea.LabelButton onClick={onClickRetry}>
          {t('error_retry_button')}
        </ErrorArea.LabelButton>
      )}
    </ErrorArea>
  );
}
